import type { Review } from '../types/chef';
import { IMG } from './images';

export const reviews: Review[] = [
  {
    id: 'rev-1',
    chefId: 'chef-elena',
    author: 'Dao Wattana',
    authorPhoto: IMG.kitchenIsland,
    date: '2026-08-22',
    rating: 5,
    scores: { food: 5, punctuality: 5, cleanliness: 5, communication: 5 },
    occasion: 'Anniversary dinner, 6 guests',
    body: 'Ploy arrived with her own mortar and wok and had the kitchen organised in ten minutes. The crab curry was the best thing I have eaten this year, and she pounded a separate mild som tam for my daughter without being asked twice. Kitchen was spotless.',
    reply: 'Thank you Dao — tell your mother the curry paste needs another ten minutes of pounding!',
  },
  {
    id: 'rev-2',
    chefId: 'chef-elena',
    author: 'Priyanka Shah',
    authorPhoto: IMG.kitchenGalley,
    date: '2026-07-30',
    rating: 5,
    scores: { food: 5, punctuality: 4, cleanliness: 5, communication: 5 },
    occasion: 'Birthday, 8 guests',
    body: 'The quote was itemised down to the wine pours, so there were no surprises at the end. She checked my sister’s shellfish allergy twice before the day and used a completely separate wok for her.',
  },
  {
    id: 'rev-3',
    chefId: 'chef-elena',
    author: 'Tom Berger',
    authorPhoto: IMG.kitchenHome,
    date: '2026-06-14',
    rating: 4,
    scores: { food: 5, punctuality: 4, cleanliness: 4, communication: 4 },
    occasion: 'Dinner party, 10 guests',
    body: 'Food was excellent. Ten was probably one too many for my condo kitchen — Ploy flagged the extractor in advance and I ignored her, which was my mistake, not hers.',
  },
  {
    id: 'rev-4',
    chefId: 'chef-kenji',
    author: 'Alice Yun',
    authorPhoto: IMG.kitchenIsland,
    date: '2026-08-02',
    rating: 5,
    scores: { food: 5, punctuality: 5, cleanliness: 5, communication: 4 },
    occasion: 'Omakase for 4',
    body: 'Four hours, eight courses, almost no conversation needed. He works so quietly you forget someone is there until the next plate appears.',
  },
  {
    id: 'rev-5',
    chefId: 'chef-amara',
    author: 'Somsak Preecha',
    authorPhoto: IMG.kitchenGalley,
    date: '2026-08-18',
    rating: 5,
    scores: { food: 5, punctuality: 5, cleanliness: 4, communication: 5 },
    occasion: 'Family gathering, 18 guests',
    body: 'The kor moo yang was properly charred, which is the whole argument. Anan moved eighteen people through lunch without ever looking rushed, and he called the day before to confirm the peanut situation for my nephew.',
    reply: 'Any time — that was a fun room.',
  },
  {
    id: 'rev-6',
    chefId: 'chef-amara',
    author: 'Rebecca Lim',
    authorPhoto: IMG.kitchenHome,
    date: '2026-07-11',
    rating: 4,
    scores: { food: 5, punctuality: 4, cleanliness: 4, communication: 5 },
    occasion: 'Weekly lunch drop',
    body: 'Five lunches, jaew sauce separate, labels on everything. Delivery came thirty minutes late one week and he took it off the next invoice without being asked.',
  },
  {
    id: 'rev-7',
    chefId: 'chef-tomas',
    author: 'Marta Ibáñez',
    authorPhoto: IMG.kitchenIsland,
    date: '2026-08-09',
    rating: 5,
    scores: { food: 5, punctuality: 4, cleanliness: 4, communication: 4 },
    occasion: 'Sunday lunch, 8 guests',
    body: 'He shopped Khlong Toei that morning and showed us every receipt, which I loved. Whole sea bass over embers on a Bangkok rooftop — worth the smoke.',
  },
  {
    id: 'rev-8',
    chefId: 'chef-priya',
    author: 'Nina Duarte',
    authorPhoto: IMG.kitchenGalley,
    date: '2026-08-25',
    rating: 5,
    scores: { food: 5, punctuality: 5, cleanliness: 5, communication: 5 },
    occasion: 'Thali night, 6 guests',
    body: 'She asked about heat tolerance for each person, not just the table, and cooked two versions of the sambar. Everything ground fresh. My kitchen smelled incredible for two days.',
  },
  {
    id: 'rev-9',
    chefId: 'chef-marcus',
    author: 'Chen Wei',
    authorPhoto: IMG.kitchenHome,
    date: '2026-08-16',
    rating: 5,
    scores: { food: 5, punctuality: 5, cleanliness: 5, communication: 4 },
    occasion: 'Family banquet, 24 guests',
    body: 'The braised goose arrived warm, the soup had clearly taken all day, and the fish was carved at the table. Cleanup was ten minutes because she brought her own trays.',
  },
  {
    id: 'rev-10',
    chefId: 'chef-sofia',
    author: 'Elise Fontaine',
    authorPhoto: IMG.kitchenIsland,
    date: '2026-07-28',
    rating: 5,
    scores: { food: 5, punctuality: 5, cleanliness: 5, communication: 5 },
    occasion: 'Vegetarian dinner, 5 guests',
    body: 'I have never seen herbs treated with that much seriousness. The baguette alone justified the booking, and she left a loaf for the morning.',
  },
];

export function reviewsForChef(chefId: string): Review[] {
  return reviews.filter((r) => r.chefId === chefId);
}

export function averageScores(chefId: string) {
  const list = reviewsForChef(chefId);
  if (!list.length) return { food: 0, punctuality: 0, cleanliness: 0, communication: 0 };
  const sum = list.reduce(
    (acc, r) => ({
      food: acc.food + r.scores.food,
      punctuality: acc.punctuality + r.scores.punctuality,
      cleanliness: acc.cleanliness + r.scores.cleanliness,
      communication: acc.communication + r.scores.communication,
    }),
    { food: 0, punctuality: 0, cleanliness: 0, communication: 0 },
  );
  return {
    food: +(sum.food / list.length).toFixed(1),
    punctuality: +(sum.punctuality / list.length).toFixed(1),
    cleanliness: +(sum.cleanliness / list.length).toFixed(1),
    communication: +(sum.communication / list.length).toFixed(1),
  };
}
